<template>
    <div>
        <vs-row vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <span :class="isMobile() ? 'titleMob' : 'title'">{{$t('message.myassetDistribution')}}</span>
            </vs-col>
            <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end">
                <span class="time">{{$t('message.lastUpdate')}}: {{currentUser.updatedAt | timeFormat}}</span>
            </vs-col>
        </vs-row>
<!--        <div style="width: 100%">-->
<!--            <GChart ref="chart" type="PieChart"-->
<!--                    :data="chartData"-->
<!--                    :options="chartOptions">-->
<!--            </GChart>-->
            <!-- <highcharts :options="chartOptions"></highcharts> -->
<!--        </div>-->
        <div class="plan-con m-t-15">
            <vs-table :data="data" stripe>
                <template slot="header">
                    <vs-row vs-type="flex" vs-align="center">
                        <vs-col vs-w="6">
                            <span :class="isMobile() ? 'titleMob' : 'title'">{{$t('message.plan')}}</span>
                        </vs-col>
                        <vs-col vs-w="6" vs-type="flex"  vs-justify="flex-end">
                            <!-- <span class="time">{{$t('message.lastUpdate')}}: {{currentUser.updatedAt | timeFormat}}</span> -->
                        </vs-col>
                    </vs-row>
                </template>
                <template slot="thead">
                    <vs-th>
                        <span style="color:#959595">{{$t('message.subscriptedPlan')}}</span>
                    </vs-th>
                    <vs-th>
                        {{$t('message.customerCode')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.currency')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.validDate')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.expiryDate')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.balanceAmount')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.expectedAnnualReturn')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.actualAnnualReturn')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.beneficiary')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.beneficiaryDeath')}}
                    </vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                        <vs-td :data="data[indextr].name">
                            <span style="color: #909090">{{lang == 'en' ? data[indextr].name : data[indextr].name_zh.tran()}}</span>
                        </vs-td>

                        <vs-td>
                            {{currentUser.customer ? currentUser.customer.code : ''}}
                        </vs-td>

                        <vs-td :data="data[indextr].currency">
                            {{data[indextr].currency}}
                        </vs-td>

                        <vs-td :data="data[indextr].effectiveDate">
                            {{data[indextr].effectiveDate | dateFormat}}
                        </vs-td>
                        <vs-td :data="data[indextr].expiryDate">
                            {{data[indextr].expiryDate | dateFormat}}
                        </vs-td>
                        <vs-td :data="data[indextr].amount">
                            {{data[indextr].amount}}
                        </vs-td>
                        <vs-td :data="data[indextr].expectedAnnualReturn">
                            {{data[indextr].expectedAnnualReturn}}
                        </vs-td>
                        <vs-td :data="data[indextr].actualAnnualReturn">
                            {{data[indextr].actualAnnualReturn}}
                        </vs-td>
                        <vs-td :data="data[indextr].beneficiaries">
                            <div v-if="tr.beneficiaries && tr.beneficiaries[0]">
                                {{data[indextr].beneficiaries.join(', ').tran()}}
                            </div>
                            <div v-else>
                                {{data[indextr].beneficiary.tran()}}
                            </div>
                        </vs-td>
                        <vs-td :data="data[indextr].beneficiariesAfterDeath">
                            <div v-if="tr.beneficiariesAfterDeath && tr.beneficiariesAfterDeath[0]">
                                {{data[indextr].beneficiariesAfterDeath.join(', ').tran()}}
                            </div>
                            <div v-else>
                                {{data[indextr].beneficiaryAfterDeath.tran()}}
                            </div>
                        </vs-td>
                        <vs-td>
                            <vs-button size="small" color="rgb(37, 105, 193)" @click="onDetail(data[indextr]._id)">{{$t('message.details')}}</vs-button>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
        <div class="fixed-term-statement m-t-15">
            <p>{{ $t('message.fixedTermStatement') }}</p>
        </div>
    </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex'
    import {Chart} from 'highcharts-vue'
    import $cookies from "vue-cookies";

    let temp = '<p style="color:{point.color};font-size:14px">{point.name}</p>' +
        '<p style="color: grey">{this.$t("message.totalConFromEffectiveDate")} : {point.other.totalNetContributionSinceEffectiveDate}</p>'


    export default {
        beforeRouteEnter(to, from, next){
            if($cookies.get('role') == 'user'){
                next()
            }else if($cookies.get('role') == 'agent'){
                next('/customer')
            }else if($cookies.get('role') == 'admin'|| $cookies.get('role') == 'manager'){
                next('/account_staff')
            }
        },
        data() {
            return {
                lang:'',
                token:'',
                data:[],
                chartOptions:{
                    chart: {
                        type: 'pie',
                        options3d: {
                            enabled: true,
                            alpha: 70,
                            beta: 0
                        },
                        marginLeft: 0,
                        marginRight: 0,
                        spacing:[0,0,0,0]
                    },
                    accessibility: {
                        point: {
                        }
                    },
                    credits:{
                        enabled:false
                    },
                    legend: {
                        itemMarginTop:10,
                        itemMarginBottom:10,
                        padding:0,
                        labelFormatter: function () {
                            return this.name;
                        }
                    },
                    title:{
                        text:null
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            depth: 50,
                            dataLabels: {
                                enabled: true,
                                padding:0,
                                softConnector: false,
                                connectorPadding:10,
                                distance:50,
                                format: '<span style="color:{point.color};font-size:14px">{point.name}</span><br>' +
                                    '<span style="color: #bdbcbc;">{point.other.totalNetContributionSinceEffectiveDate}</span><br>' +
                                    '<span style="color: #bdbcbc">{point.other.totalTransferAsset}</span><br>' +
                                    '<span style="color: #bdbcbc">{point.other.totalTransferOutAsset}</span><br>' +
                                    '<span style="color: #bdbcbc">{point.other.investmentBalanceSinceEffectiveDate}</span><br>' +
                                    '<span style="color: #bdbcbc">{point.other.balance}</span><br>' +
                                    '<span style="color: #bdbcbc">{point.other.return}</span>'
                            }
                        }
                    },
                    colors:['rgb(219,81,79)','rgb(59,125,151)','rgb(37,177,148)','rgb(232,161,61)','rgb(37, 105, 193)','rgb(232, 193, 137)'],
                    tooltip: {
                        pointFormat: '<b>{point.x}</b> <b>{point.y:,.0f}</b>'

                    },
                    series: [{
                        type: 'pie',
                        data: [
                            // {
                            //     name: 'Plan',
                            //     x:'HKD',
                            //     y: 1000
                            // },
                        ],
                        // showInLegend: true
                    }]
                }
            }
        },
        created() {
            this.lang = this.$cookies.get('lang')
            if(screen.width < 400){
                this.chartOptions.legend = 'none';
                this.chartOptions.height = 300;
            }

            let url = process.env.VUE_APP_API_BASEURL + '/api/me?access_token=' + this.$cookies.get('token');
            fetch(url).then((res) => {
                return res.json()
            }).then((data) => {
                this.data = data.responseDetail.plans
                let arr = data.responseDetail.plans.map((item)=>{
                    let obj = {
                        name:this.$cookies.get('lang') == 'en' ? item.name : item.name_zh.tran(),
                        x:this.$t(`message.${item.currency}`),
                        y:item.amount,
                        other:{
                            totalNetContributionSinceEffectiveDate : `${this.$t('message.totalConFromEffectiveDate')} : ${item.totalNetContributionSinceEffectiveDate.toLocaleString()}`,
                            totalTransferAsset : `${this.$t('message.totalConTransInAssets')} : ${item.totalTransferAsset.toLocaleString()}`,
                            totalTransferOutAsset : `${this.$t('message.totalWithTransOutAssets')} : ${item.totalTransferOutAsset.toLocaleString()}`,
                            investmentBalanceSinceEffectiveDate : `${this.$t('message.profitorLossFromEffectiveDate')} : ${item.investmentBalanceSinceEffectiveDate.toLocaleString()}`,
                            balance : `${this.$t('message.accountBalance')} : ${item.balance.toLocaleString()}`,
                            return : `${this.$t('message.accountReturns')} : ${item.return.toLocaleString()}`,
                        }

                    }
                    return obj
                })
                this.chartOptions.series[0].data = arr;
                if(screen.width < 500){
                    this.chartOptions.plotOptions.pie.dataLabels.enabled = false ;
                    this.chartOptions.tooltip.pointFormat = '<span style="color: #b1b1b1;">{point.other.totalNetContributionSinceEffectiveDate}</span><br>' +
                        '<span style="color: #b1b1b1">{point.other.totalTransferAsset}</span><br>' +
                        '<span style="color: #b1b1b1">{point.other.totalTransferOutAsset}</span><br>' +
                        '<span style="color: #b1b1b1">{point.other.investmentBalanceSinceEffectiveDate}</span><br>' +
                        '<span style="color: #b1b1b1">{point.other.balance}</span><br>' +
                        '<span style="color: #b1b1b1">{point.other.return}</span>';
                    this.chartOptions.legend.labelFormatter = function(){
                        return this.name
                    }
                }


            })


        },
        computed:{
            ...mapGetters(["currentUser"])
        },
        methods: {
            onDetail(idx){
                this.$router.push({name:'detail',params:{id:idx}})
            }
        },
        components: {
            highcharts:Chart
        },
    }
</script>

<style scoped>
    @import '../assets/css/table.css';

    .fixed-term-statement {
        padding: 12px 16px;
        border-top: 1px solid #e8e8e8;
    }

    .fixed-term-statement p {
        font-size: 8px;
        color: #999;
        line-height: 1.2;
        margin: 0;
        white-space: pre-wrap;
    }

    .fixed-term-statement .statement-title {
        font-weight: 600;
        margin-bottom: 4px;
    }
</style>
<style>
    .highcharts-pie-series .highcharts-point {
        stroke-width: 2px;
    }
    .highcharts-pie-series .highcharts-data-label-connector {
        stroke-width: 2px;
    }
</style>
